/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTheme } from "../../../ThemeContext";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    maxWidth: "400px",
    width: "100%",
    margin: "16px",
    padding: "16px",
  },
}));

const StyledDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "24px !important",
  textAlign: "center",
});

const StyledImage = styled("img")({
  width: "150px",
  height: "150px",
  marginBottom: "16px",
});

const TransactionSuccess = () => {
  const { themeMode } = useTheme();

  return (
    <StyledDialog open={true}>
      <StyledDialogContent>
        <StyledImage
          src={themeMode === "dark" ? "/gifs/transaction-success.gif" : "/gifs/transaction-success.gif"}
          alt="Transaction Success"
        />
        <Typography variant="h6" style={{ color: "#04002b", marginBottom: "8px", fontWeight: "600" }}>
          Payment Successful!
        </Typography>
        <Typography variant="body1" style={{ color: "#666666" }}>
          Your transaction has been completed successfully.
        </Typography>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default TransactionSuccess;